/**
 * @generated SignedSource<<d06257992e56a1048850a51c83851a43>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AskFellowPanelInner_ToolUseAndResult_use$data = {
  readonly contentJson: any | null;
  readonly " $fragmentType": "AskFellowPanelInner_ToolUseAndResult_use";
};
export type AskFellowPanelInner_ToolUseAndResult_use$key = {
  readonly " $data"?: AskFellowPanelInner_ToolUseAndResult_use$data;
  readonly " $fragmentSpreads": FragmentRefs<"AskFellowPanelInner_ToolUseAndResult_use">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AskFellowPanelInner_ToolUseAndResult_use",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contentJson",
      "storageKey": null
    }
  ],
  "type": "AskCopilotMessage",
  "abstractKey": null
};

(node as any).hash = "2cf9f634cccf66a05962c16e97725522";

export default node;
